export { MultiTinRegistrationStatus } from './MultiTinRegistrationStatus';
